import { createAction } from 'typesafe-actions';

import * as AnalyticsConstants from './constants';

interface LogEventParams {
  eventType: $TSFixMe;
  eventName: $TSFixMe;
  eventData: $TSFixMe;
}

export const logEvent = createAction(
  AnalyticsConstants.Actions.LOG_EVENT,
  (params: LogEventParams) => params,
)<LogEventParams>();
export type LogEventAction = ReturnType<typeof logEvent>;
